import classnames from "classnames";

import "./pageLink.scss";

export type PageLinkProps = {
    link: string;
    label: string;
    spread?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
};

const PageLink = ({ link, label, spread = 0 }: PageLinkProps) => {
    return (
        <a
            data-test={`pageLink-${label}-link`}
            href={link}
            className={classnames("d-block", `py-${spread}`, "pl__item")}
        >
            <div className={classnames("pl__listitem")}>{label}</div>
        </a>
    );
};

export default PageLink;
